import Vue from 'vue'
import { omit } from 'lodash'
import inform from '@/services/inform'
import { clearLabels, saveLabels, updateLabels } from './labels'
import { updateVariantInList } from './variants'

// State
const state = {
  isLoading: false,
  isSaving: false,
  isPublishing: false,
  isRevoking: false,
  data: null
}

// Mutations
const updateVariant = 'updateVariant'
const saveVariantRequest = 'saveVariantRequest'
const saveVariantResponse = 'saveVariantResponse'
const publishVariantRequest = 'publishVariantRequest'
const publishVariantResponse = 'publishVariantResponse'
const revokeVariantRequest = 'revokeVariantRequest'
const revokeVariantResponse = 'revokeVariantResponse'
export const resetVariant = 'resetVariant'
export const updateSlogan = 'updateSlogan'

const mutations = {
  [updateVariant] (state, variant) {
    state.data = { ...state.data, ...variant }
  },
  [saveVariantRequest] (state) {
    state.data.isSaving = true
  },
  [saveVariantResponse] (state, variant) {
    state.data.isSaving = false
    state.data = { ...state.data, ...variant }
  },
  [updateSlogan] (state, slogan) {
    state.data.slogan = slogan
    state.data.sloganId = slogan.id
  },
  [resetVariant] (state) {
    state.data = null
    state.isLoading = false
  },
  [publishVariantRequest] (state) {
    state.isSaving = true
    state.isPublishing = true
  },
  [publishVariantResponse] (state, variant) {
    state.data = { ...state.data, ...variant }
    state.isSaving = false
    state.isPublishing = false
  },
  [revokeVariantRequest] (state) {
    state.isSaving = true
    state.isRevoking = true
  },
  [revokeVariantResponse] (state, variant) {
    state.data = { ...state.data, ...variant }
    state.isSaving = false
    state.isRevoking = false
  }
}

// Actions
export const selectVariant = 'selectVariant'
export const unselectVariant = 'unselectVariant'
export const setDefaultVariant = 'setDefaultVariant'
export const renameVariant = 'renameVariant'
export const saveVariant = 'saveVariant'
export const publishVariant = 'publishVariant'
export const revokeVariant = 'revokeVariant'

const actions = {
  [selectVariant] ({ state, rootState, dispatch, commit }, variant) {
    if (variant.id === state.data.id) {
      return
    }
    // Store the actual changes if a user hasn't stored them before switching to another variant
    if (rootState.labels.isDirty) {
      dispatch(saveLabels, false)
    }
    commit(updateVariant, variant)
    commit(updateLabels, variant.labels)
  },
  [unselectVariant] ({ state, commit }) {
    commit(updateVariant, null)
    commit(clearLabels, [])
  },
  [saveVariant] ({ state, commit, dispatch }, variant) {
    commit(saveVariantRequest)
    return Vue.http
      .put(`${SERVER_URL}/variants/${variant.id}`, omit(variant, 'slogan'))
      .then(({ data: variant }) => {
        commit(saveVariantResponse, variant)
        commit(updateVariantInList, variant)
      })
  },
  [setDefaultVariant] ({ state, rootState, commit, dispatch }) {
    const variantId = state.data.id
    dispatch(saveVariant, { ...state.data, isDefault: true }).then(() => {
      rootState.variants.data
        .filter(({ id }) => id !== variantId)
        .forEach(variant => {
          commit(updateVariantInList, { ...variant, isDefault: false })
        })
    })
  },
  [renameVariant] ({ state, commit, dispatch }, name) {
    dispatch(saveVariant, { ...state.data, name })
  },
  [publishVariant] ({ state, commit }, { sign, variant }) {
    commit(publishVariantRequest)
    return Vue.http
      .post(`${SERVER_URL}/publish/${sign.id}/${variant.id}`)
      .then(({ data: variant }) => {
        inform(
          `Die Variante "${variant.name}" wurde erfolgreich veröffentlicht`,
          'is-success'
        )
        commit(publishVariantResponse, variant)
        commit(updateVariantInList, variant)
      })
  },
  [revokeVariant] ({ state, commit }, { sign, variant }) {
    commit(revokeVariantRequest)
    return Vue.http
      .delete(`${SERVER_URL}/publish/${sign.id}/${variant.id}`)
      .then(({ data: variant }) => {
        inform(
          `Die Variante "${variant.name}" wurde erfolgreich zurückgezogen`,
          'is-warning'
        )
        commit(revokeVariantResponse, variant)
        commit(updateVariantInList, variant)
      })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/variant.js